export default function yupCreditCardNameValidate(y) {
  y.addMethod(y.string, "firstNameCheck", function () {
    return this.test(
      "firstNameCheck",
      "1文字以上22文字以下の英字で入力してください。",
      function (value) {
        const length = value.length;
        return (
          length >= 1 && length <= 22 && /^[a-zA-Z!-/:-@[-`{-~]+$/.test(value)
        );
      }
    );
  });
  y.addMethod(y.string, "lastNameCheck", function () {
    return this.test(
      "lastNameCheck",
      "1文字以上22文字以下の英字で入力してください。",
      function (value) {
        const length = value.length;
        return (
          length >= 1 && length <= 22 && /^[a-zA-Z!-/:-@[-`{-~]+$/.test(value)
        );
      }
    );
  });
}
